import InvestorDashboard from "./investor-dashboard";

export default InvestorDashboard;
